import { useEffect, useState } from "react";
import { Modal } from "@/components/ui/Modal";
import { Button } from "@/components/ui/Button";
import { useSetAssetVisibility } from "../hooks/useAssetRegistry";
import { VISIBILITY_LABELS, type Asset, type AssetVisibility } from "../types";
import { extractError } from "../utils";

interface Props {
  open: boolean;
  onClose: () => void;
  asset: Asset | null;
}

export function SetVisibilityModal({ open, onClose, asset }: Props) {
  const [visibility, setVisibility] = useState<AssetVisibility>("all");
  const [error, setError] = useState("");
  const setVis = useSetAssetVisibility();

  useEffect(() => {
    if (open && asset) {
      setVisibility(asset.visibility);
      setError("");
    }
  }, [open, asset]);

  function submit() {
    if (!asset) return;
    setVis.mutate(
      { id: asset.id, visibility },
      { onSuccess: () => onClose(), onError: (e) => setError(extractError(e)) },
    );
  }

  return (
    <Modal open={open} onClose={onClose} title={asset ? `Widoczność: ${asset.name}` : "Widoczność"}>
      <div className="space-y-3">
        {(["all", "holder"] as AssetVisibility[]).map((v) => (
          <label
            key={v}
            className="flex items-start gap-3 p-3 border border-[var(--color-border)] cursor-pointer hover:bg-[var(--color-bg-elevated)]"
          >
            <input
              type="radio"
              name="visibility"
              checked={visibility === v}
              onChange={() => setVisibility(v)}
              className="mt-0.5"
            />
            <span className="text-sm text-[var(--color-text-primary)]">{VISIBILITY_LABELS[v]}</span>
          </label>
        ))}
        {error && <p className="text-xs text-red-600">{error}</p>}
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="ghost" onClick={onClose}>
            Anuluj
          </Button>
          <Button onClick={submit} loading={setVis.isPending}>
            Zapisz
          </Button>
        </div>
      </div>
    </Modal>
  );
}
